import { positions, transitions } from 'react-alert';

export const alertOptions = {
  position: positions.BOTTOM_RIGHT,
  timeout: 10000,
  transition: transitions.SCALE,
};
